import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';
import { DoorBookingsResponse } from './doorApiTypes';

// Locker (Fach) history — GET /admin/depots/:depotId/doors/:door/bookings on
// the new (ECS) backend.
//
// A slice of its own rather than an endpoint on `doorApiSlice`: that slice is
// bound to the old Lambda base query for block/unblock, and one createApi has
// exactly one baseQuery. New endpoints belong on the new backend (lead dev,
// 2026-08-28), so the two cannot share a slice until block/unblock migrates.
export const doorHistoryApiSlice = createApi({
    reducerPath: 'doorHistoryApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    tagTypes: ['doorBookings'],
    endpoints: (builder) => ({
        getDoorBookings: builder.query<
            DoorBookingsResponse,
            { depotId: string, door: number, limit?: number }
        >({
            query: ({ depotId, door, limit }) => ({
                url: `/depots/${encodeURIComponent(depotId)}/doors/${door}/bookings`,
                ...(limit ? { params: { limit } } : {}),
            }),
            providesTags: ['doorBookings'],
        }),
    }),
});

export const { useGetDoorBookingsQuery } = doorHistoryApiSlice;
